
$(document).ready(function() {
  
  $('.template- .page-title h1').fadeIn(1000).text('FAQ');
  
  $('div.hidden').fadeIn(1000).removeClass('hidden');
  
  var imgs = $('.one-fourth');//jQuery class selector
  imgs.each(function(){
    var img = $(this);
    var width = img.width(); //jQuery width method
    var height = img.height(); //jQuery height method
    if(width < height){
       img.addClass('portrait');
    }else{
       img.addClass('landscape');
    }
  })
  
  $("div.grid-product__wrapper").each(function(i) {
      $(this).find("span.number").text(++i);
  });  
  
  $(".size-fit-btn, .close").click(function() {
	$(".size-fit").fadeToggle("slow");	
  });
  
  
  
 	/* Hover Display Text */
    $('.layout-1 img').hover(function() {
      	var boxOpacity = parseInt($('.text-1').css('opacity'));
      	$('.text-1').fadeToggle({
          	opacity: boxOpacity == 0 ? 1 : 0
      	});
  	});
  
    $('.layout-2 img').hover(function() {
      	var boxOpacity = parseInt($('.text-2').css('opacity'));
      	$('.text-2').fadeToggle({
          	opacity: boxOpacity == 0 ? 1 : 0
      	});
  	});
  
    $('.layout-3 img').hover(function() {
      	var boxOpacity = parseInt($('.text-3').css('opacity'));
      	$('.text-3').fadeToggle({
          	opacity: boxOpacity == 0 ? 1 : 0
      	});
  	});
  
    $('.layout-4 img').hover(function() {
      	var boxOpacity = parseInt($('.text-4').css('opacity'));
      	$('.text-4').fadeToggle({
          	opacity: boxOpacity == 0 ? 1 : 0
      	});
  	});   

    $('.layout-5 img').hover(function() {
      	var boxOpacity = parseInt($('.text-5').css('opacity'));
      	$('.text-5').fadeToggle({
          	opacity: boxOpacity == 0 ? 1 : 0
      	});
  	});   
  
  
});


$(window).load(function(){   
  
 $('.one-fourth').find('img').each(function(){
  var imgClass = (this.width/this.height > 1) ? 'wide' : 'tall';
  $(this).addClass(imgClass);
 })
})


if ($(window).width() < 600) {
  }

else {
  
  $.fn.moveIt = function(){
    var $window = $(window);
    var instances = [];

    $(this).each(function(){
      instances.push(new moveItItem($(this)));
    });

    window.onscroll = function(){
      var scrollTop = $window.scrollTop();
      instances.forEach(function(inst){
        inst.update(scrollTop);
      });
    }
  }

  var moveItItem = function(el){
    this.el = $(el);
    this.speed = parseInt(this.el.attr('data-scroll-speed'));
  };

  moveItItem.prototype.update = function(scrollTop){
    var pos = scrollTop / this.speed;
    this.el.css('transform', 'translateY(' + -pos + 'px)');
  };

  $(function(){
    $('[data-scroll-speed]').moveIt();
  });

}  